import React from 'react';
import PropTypes from 'prop-types';

import TooltipWrapper from 'components/TooltipWrapper';

import { toI18n } from 'util/i18n';

const TempUserToolTip = ({ name, enabled, children }) => (
  <TooltipWrapper
    enabled={enabled}
    content={toI18n(
      'team.employee_profile.employee_information.tooltips.temp_user',
      {
        props: {
          name,
        },
      }
    )}
  >
    {children}
  </TooltipWrapper>
);

TempUserToolTip.propTypes = {
  name: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired,
  children: PropTypes.element.isRequired,
};

export default TempUserToolTip;
